<template>
  <div style="height:100%">
    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      :reprint="notify.reprint" :rePrintData="notify.rePrintData"
                      @dialogClose="notify.show = false"></my-notify-dialog>

    <div class="common-page-box">
      <div class="back-btn" @click="$router.back()">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
      </div>

      <div class="page-title" style="margin-top:32px">{{ title }}</div>

      <!-- 双栏：左输入须知 / 右数字键盘（对齐 11-code-enter 设计稿） -->
      <div class="card" style="margin:40px 96px 72px;flex:1;padding:64px 88px;display:flex;gap:88px;overflow:auto">
        <template v-if="!showApplyList">
          <div style="flex:1;display:flex;flex-direction:column;min-width:0">
            <div class="field-label" style="margin-bottom:24px">{{ field }}</div>
            <input class="ta-input" style="width:100%" placeholder="请输入访客码" readonly :value="inputCode" @click="onInputClick">
            <button class="ta-btn primary" style="width:100%;margin-top:32px" @click="onEnsureClick">搜 索</button>
            <div v-if="agreement.valid" class="agree" style="margin-top:36px" @click="haveRead = !haveRead">
              <span class="box" :class="{ checked: haveRead }">
                <svg v-if="haveRead" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5.5 5.5L20 6.5"/></svg>
              </span>
              <span>请阅读并同意<a>《{{ agreementTitle }}</a></span>
            </div>
            <div class="notice" style="margin-top:auto;border-top:1px solid var(--line);padding-top:36px;font-size:28px;line-height:1.75">
              <h3 style="font-size:32px">{{ agreementTitle }}</h3>
              <div v-if="agreement.valid" v-html="agreement.content"></div>
              <div v-else>访问结束，签离前请注意：<br>
            1. 请出示签到时使用的二维码、访客码或预留手机号完成签离；<br>
            2. 请携带好个人物品，有序离开；<br>
            感谢您的配合，欢迎再次来访。</div>
            </div>
          </div>

          <div style="width:640px;align-self:center;flex:none">
            <num-keyboard @inputCallback="inputCode = $event"></num-keyboard>
          </div>
        </template>

        <el-table v-if="showApplyList" :data="applyList" style="width:100%">
          <el-table-column prop="myVisitorName" label="访客"></el-table-column>
          <el-table-column prop="myEmployeeName" label="受访者"></el-table-column>
          <el-table-column prop="myBeginTime" label="开始时间"></el-table-column>
          <el-table-column prop="myEndTime" label="结束时间"></el-table-column>
          <el-table-column prop="myStatus" label="状态">
            <template v-slot="scope">
              <el-tag>{{ scope.row.myStatus | tableDateFilter }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button :disabled="scope.row.myStatus !== 'PASS'" @click="doSignLeave(scope.row.data)"
                         type="success">
                签离
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>


import BackIcon from "@/components/BackIcon";

import {getApplyListByPinCode, signLeave} from "@/api/visit-api";
import NumKeyboard from "@/components/NumKeyboard.vue";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {areaCheckMixin} from "@/utils/myMixins";

export default {
  name: "PinCodeLeave",
  components: {MyNotifyDialog, NumKeyboard, BackIcon},
  mixins: [areaCheckMixin],

  mounted() {
    this.setupAreaInfo()
  },
  computed: {
    agreement() {
      return this.$store.state.signLeaveAgreement
    },

  },
  data() {
    return {
      title: "访客码签离",

      subTitle: "访客码",
      inputCode: "",
      haveRead: false,


      applyList: [],
      showApplyList: false,

      notify: {
        title: "签到结果",
        show: false,
        success: true,
        msg: "签到成功",
      },

      agreementTitle: "签离须知",

      inputShow: true,
    }
  }, // end data

  methods: {
    onInputClick() {
      if (!this.inputShow) {
        this.inputShow = true
        this.inputCode = ""
      }
    },
    onCancelClick() {
      this.$router.back()
    },
    onEnsureClick() {
      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }
      let visitCode = this.inputCode
      if (!visitCode || visitCode.length !== 8) {
        this.$message.warning("请输入8位访客码")
        return
      }
      this.inputShow = false
      this.applyList = []
      getApplyListByPinCode(visitCode).then(({data}) => {
        if (data.code === 200) {
          let applyList = data.data
          if (applyList.length > 0) {
            applyList.forEach(item => {
              this.applyList.push({
                myVisitorName: item.pinVisitor.name,
                myEmployeeName: item.employee.name,
                myBeginTime: item.beginDate + " " + item.beginTime,
                myEndTime: item.endDate + " " + item.endTime,
                myStatus: item.state,
                data: item
              })
            })
            this.showApplyList = true
            if (this.applyList.length === 1 && this.applyList[0].myStatus === "PASS") {
              this.doSignLeave(this.applyList[0].data)
            }
          } else {
            this.$message.warning("查询失败，未能找到对应的申请记录")
          }
        } else {
          this.showNetErrMsg(data.code)
          this.logE("VisitCodeLeave getApplyListByPinCode false", data.code, data.msg)
        }
      }).catch((err) => {
        this.logE("VisitCodeLeave getApplyListByPinCode err", err)
        this.showNetErrMsg()
      })
    },

    doSignLeave(applyInfo) {
      let applyId = applyInfo.id
      let visitorCode = applyInfo.pinVisitor.code
      let deviceId = this.$store.state.deviceId
      let areaId = this.$store.state.areaId
      signLeave(applyId, visitorCode, deviceId, areaId).then(({data}) => {
        console.log("signLeave", data)
        if (data.code === 200) {
          if (data.data.exist === "EXIST") {
            this.notify = {title: "签离结果", show: true, false: true, msg: "您已签离，无需再次签离",}
          } else {
            this.notify = {title: "签离结果", show: true, success: true, msg: "签离成功",}
          }

        } else if (data.code === 720) {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "未同意签离或者签离超时",
          }
        } else if (data.code === 201) {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "签离失败，没有找到签到记录",
          }
        }  else {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "签离失败",
          }
        }
      }).catch((err) => {
        this.notify = {
          title: "签离结果",
          show: true,
          success: false,
          msg: "签离失败，网络异常",
        }
        this.logE("VisitCodeLeave signLeave err", err)
      })
    },
  }, // end methods
  filters: {
    tableDateFilter(value) {
      switch (value) {
        case 'PASS':
          return "审批通过"
        case 'REJECT':
          return "审批拒绝"
        case 'CANCEL':
          return "审批撤销"
        case 'PROCESS ':
        case 'NONE ':
        default:
          return "审批中"
      }
    }
  }
}
</script>
<style scoped lang="less">
.back-btn {
  position: absolute;
  top: 88px;
  right: 72px;
  z-index: 20;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  background: var(--panel);
  border: 1px solid var(--line);
  box-shadow: var(--shadow-card);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
